import axios from 'axios';
import api from '../base';

export function getUser() {
    return axios({
        method: 'get',
        url: '/api/v1/users/profile',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function authUser(email, password) {
    return axios({
        method: 'post',
        url: '/api/v1/auth/sign_in',
        withCredentials: true,
        data: {
            email,
            password,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function logoutUser() {
    return axios({
        method: 'get',
        url: '/api/v1/users/logout',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function createNewUser(user) {
    return axios({
        method: 'post',
        url: '/api/v1/auth/register',
        data: {
            name: user.name,
            surname: user.name,
            email: user.email,
            company: user.company,
            phones: user.phones,
        },
        withCredentials: true,
    });
}

export function findUser(text, extend = false, companyName = undefined) {
    return axios({
        method: 'post',
        url: '/api/v1/users/find',
        data: {
            query: text,
            extend,
            companyName,
        },
        withCredentials: true,
    });
}

export function findUserById(user) {
    return axios({
        method: 'post',
        url: '/api/v1/users/find-by-id',
        data: {
            query: user.user._id,
        },
        withCredentials: true,
    })
    .then(response => response.data.data)
    .catch(error => console.error(error));
}

export function findUsers(users) {
    return axios({
        method: 'post',
        url: '/api/v1/users/find-users',
        data: {
            query: users
        },
        withCredentials: true,
    })
    .then(response => response.data.data)
    .catch(error => console.error(error));
}

export function getCompanyCollegues(userId) {
    return axios({
        method: 'get',
        url: '/api/v1/companies/users',
        data: {
            query: userId,
        },
        withCredentials: true,
    });
}

export function getUserList({ page = 1, limit = 25 }) {
    return axios({
        method: 'post',
        url: '/api/v1/users',
        withCredentials: true,
        data: {
            page,
            limit,
            select: ["limitations"],
        }
    })
        .then(response => response)
        .catch(response => response.response.data);
}

export function banUserById(user) {
    return axios({
        method: 'put',
        url: `/api/v1/users/${user._id}/ban`,
        withCredentials: true,
    })
        .then(response => response.data.data)
        .catch(response => response.response.data);
}

export function unbanUserById(user) {
    return axios({
        method: 'put',
        url: `/api/v1/users/${user._id}/unban`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getUserLimitationsList() {
    return axios({
        method: 'get',
        url: '/api/v1/users/profile/limitation',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}


export function setUserToBlackList(emails, user) {
    return axios({
        method: 'put',
        url: '/api/v1/users/profile/limitation/black',
        withCredentials: true,
        data: {
            emails,
            user: user._id,
        }
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function setUserToWhiteList(emails, user) {
    return axios({
        method: 'put',
        url: '/api/v1/users/profile/limitation/white',
        withCredentials: true,
        data: {
            emails,
            user: user._id,
        }
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function toggleWhiteList(user, whiteActive) {
    return axios({
        method: 'post',
        url: '/api/v1/users/profile/limitation/toggle',
        withCredentials: true,
        data: {
            user: user._id,
            whiteActive,
        }
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

async function getOne(id) {
  return await api.call(`users/${id}`)
}

// not necessary due to stripe integration
// async function extendSubscription(id, data) {
//   return await api.call(`users/${id}/subscription`, data, 'put');
// }

export default {
  getOne,
//   extendSubscription
}



// WEBPACK FOOTER //
// ./app/services/users/index.js